import React from 'react'
import { VolunteeringExerciseProvider } from './VolunteeringExerciseProvider'
import Page from './Page'

const VolunteeringExercise = ({ ...props }) => {
  return (
    <VolunteeringExerciseProvider {...props}>
      <Page />
    </VolunteeringExerciseProvider>
  )
}

export default VolunteeringExercise
